/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown>, from: NonNullable<unknown>, to: NonNullable<unknown>, every: NonNullable<unknown>, minutes: NonNullable<unknown> }} Irrigation_Schedule_Summary_IntervalInputs */

const vi_irrigation_schedule_summary_interval = /** @type {(inputs: Irrigation_Schedule_Summary_IntervalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days}, từ ${i?.from} đến ${i?.to}, cứ ${i?.every} phút tưới ${i?.minutes} phút`)
};

/**

* @param {Irrigation_Schedule_Summary_IntervalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_summary_interval = /** @type {((inputs: Irrigation_Schedule_Summary_IntervalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Summary_IntervalInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_summary_interval(inputs)
});